import React from "react";
import withExplorerCommunityLogic from "../hoc/communities/withExplorerCommunityLogic";
import CommunityFilterBase from "../base/CommunityFilterBase";

const FilterComponent = withExplorerCommunityLogic(CommunityFilterBase);
const ExplorerCommunityFilter = React.memo(FilterComponent);

export default ExplorerCommunityFilter;
